import React from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem } from 'reactstrap';
import './NavMenu.css';

export default class NavMenu extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false
        };
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    render() {
        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow" light >
                    <Container>
                        <NavbarBrand href="/" >
                            <img src="/images/logoweb.png" height="60" alt="" />
                        </NavbarBrand>
                        <NavbarToggler onClick={this.toggle} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={this.state.isOpen} navbar>
                            <ul className="navbar-nav flex-grow">
                                <NavItem>
                                    <a href="https://www.yb.co.id/">Back to Website</a>
                                </NavItem>
                                {/* <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/Education">Education</NavLink>
                                </NavItem> */}
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.js